import axios from 'axios';
import AuthService from '../utils/authService';
import Moment from 'moment';
import * as constants from '../utils/constants';

const baseurl = constants.default.baseUrl


const SiteLogAPI = {

    getPicop: () => {

        return axios.get(baseurl + '/api/picops',
             { headers: { Authorization: `Bearer ${AuthService.getToken()}` }});
        
    },

    getWorkTypes: () => {
        return axios.get(baseurl + '/api/workType',
        { headers: { Authorization: `Bearer ${AuthService.getToken()}` }});
    },

    getStartTimeLoss: () => {

        return axios.get(baseurl + '/api/worksite/getStartTimeLoss',  
             { headers: { Authorization: `Bearer ${AuthService.getToken()}` }});
    },

    getEndTimeLoss: () => {

        return axios.get(baseurl + '/api/worksite/getEndTimeLoss',  
             { headers: { Authorization: `Bearer ${AuthService.getToken()}` }});
    },

    getWorksiteStats2: () => {

        return axios.get(baseurl + '/api/worksite/getWorksiteStats2',  
             { headers: { Authorization: `Bearer ${AuthService.getToken()}` }});
    },

    getSiteLogs: (str) => {

        return axios.get(baseurl + '/api/sitelog?' + str, 
             { headers: { Authorization: `Bearer ${AuthService.getToken()}` }});
    },

    getSiteLogById: (sitelogId) => {

        return axios.get(baseurl + '/api/sitelog/getSiteLogById?projectid=0&sitelogid=' + sitelogId,
             { headers: { Authorization: `Bearer ${AuthService.getToken()}` }});
    },

    getSummary: (sitelogId) => {

        return axios.get(baseurl + '/api/sitelog/summary?sitelogid=' + sitelogId,
             { headers: { Authorization: `Bearer ${AuthService.getToken()}` }});
        
    },

    getWorksites: (sitelogId, worksiteId) => {

        return axios.get(baseurl + '/api/worksite?sitelogid=' + sitelogId + '&worksiteid=' + worksiteId,
             { headers: { Authorization: `Bearer ${AuthService.getToken()}` }});

    },

    getWorksitesSummary: (sitelogId) => {

        return axios.get(baseurl + '/api/worksite?sitelogid=' + sitelogId,
             { headers: { Authorization: `Bearer ${AuthService.getToken()}` }});

    },

    getActivities: (worksiteId, activityId) => {

        return axios.get(baseurl + '/api/activity?worksiteid=' + worksiteId + '&activityId=' + activityId,
             { headers: { Authorization: `Bearer ${AuthService.getToken()}` }});

    },


    getActivitiesSummary: (worksiteId, activityId) => {

        return axios.get(baseurl + '/api/activity?worksiteid=' + worksiteId,
             { headers: { Authorization: `Bearer ${AuthService.getToken()}` }});

    },

    getOTPs: (worksiteId, otpId) => {

        return axios.get(baseurl + '/api/otp?worksiteid=' + worksiteId + '&otpId=' + otpId,
             { headers: { Authorization: `Bearer ${AuthService.getToken()}` }});

    },

    getOTPsSummary: (worksiteId) => {

        return axios.get(baseurl + '/api/otp?worksiteid=' + worksiteId,
             { headers: { Authorization: `Bearer ${AuthService.getToken()}` }});

    },

    getAccidents: (worksiteId, accidentId) => {

        return axios.get(baseurl + '/api/accident?worksiteid=' + worksiteId + '&accidentId=' + accidentId,
             { headers: { Authorization: `Bearer ${AuthService.getToken()}` }});

    },

    getAuthorityTrackers: (worksiteId, authorityId) => {

        return axios.get(baseurl + '/api/authorityTracker?worksiteid=' + worksiteId + '&authorityId=' + authorityId,
             { headers: { Authorization: `Bearer ${AuthService.getToken()}` }});

    },

    getAuthorityTrackersSummary: (worksiteId) => {

        return axios.get(baseurl + '/api/authorityTracker?worksiteid=' + worksiteId,
             { headers: { Authorization: `Bearer ${AuthService.getToken()}` }});

    },

    getAccidentsSummary: (worksiteId) => {

        return axios.get(baseurl + '/api/accident?worksiteid=' + worksiteId,
             { headers: { Authorization: `Bearer ${AuthService.getToken()}` }});

    },

      
    delete: (path, id) => {

        return axios.delete(baseurl + path, 
        { params: { id: id }, 
          headers: { Authorization: `Bearer ${AuthService.getToken()}` }});

    },

    saveSiteLog: (obj) => {

        
        return axios({
            method: 'post',
            url: baseurl + '/api/sitelog',
            data: obj,
            headers: { Authorization: `Bearer ${AuthService.getToken()}` } 
        })
    },
    
    deleteSitelog: (id) => {

        return axios.delete(baseurl + '/api/sitelog', 
        { params: { id: id }, 
          headers: { Authorization: `Bearer ${AuthService.getToken()}` }});

    },


    saveWorksite: (obj) => {
        
        return axios({
            method: 'post',
            url: baseurl + '/api/worksite',
            data: obj,
            headers: { Authorization: `Bearer ${AuthService.getToken()}` } 
        })
    },

    saveActivity: (obj) => {
        
		
        return axios({
            method: 'post',
            url: baseurl + '/api/activity',
            data: obj,
            headers: { Authorization: `Bearer ${AuthService.getToken()}` } 
        })
    },

    saveOTP: (obj) => {
		
		
        return axios({
            method: 'post',
            url: baseurl + '/api/otp',
            data: obj,
            headers: { Authorization: `Bearer ${AuthService.getToken()}` } 
        })

    },

    saveAuthorityTracker: (obj) => {

	    return axios({
            method: 'post',
            url: baseurl + '/api/authorityTracker',
            data: obj,
            headers: { Authorization: `Bearer ${AuthService.getToken()}` } 
        })

    },

    saveAccident: (obj) => {

				
        return axios({
            method: 'post',
            url: baseurl + '/api/accident',
            data: obj,
            headers: { Authorization: `Bearer ${AuthService.getToken()}` } 
        })

    }
}

export default SiteLogAPI;
